import React, { useState, useContext, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
// style
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
// components
import { EventContext } from '../../../contexts/Event';
// helpers
import { getTimeZoneDate } from '../../../helpers/Util';

export default function EventCalendarTabs() {
  const { event } = useContext(EventContext);

  const [currentDate, setCurrentDate] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    setCurrentDate(false);
    const date = searchParams.get('eventDate');

    if (date) {
      setCurrentDate(getTimeZoneDate({ date }).toISOString());
    }
  }, [searchParams]);

  const handleChange = (_, newCurrentDate) => {
    setCurrentDate(newCurrentDate);
    setSearchParams(updateSearchParams('eventDate', newCurrentDate));
  };

  // TODO: Colocar essa função no helper
  const updateSearchParams = (key, value, remove) => {
    const params = new URL(document.location).searchParams;

    const updatedSearchParams = new URLSearchParams(params.toString());

    if (remove) {
      updatedSearchParams.delete(key);
    } else {
      updatedSearchParams.set(key, value);
    }
    return updatedSearchParams.toString();
  };

  return (
    <Box sx={{ maxWidth: { xs: 320, sm: 480 }, bgcolor: 'background.paper' }}>
      <Typography variant="h6" gutterBottom>
        Event Date
      </Typography>
      <Tabs
        value={currentDate}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons
        allowScrollButtonsMobile
        aria-label="scrollable force tabs example"
      >
        {event.calendar.schedule.map((schedule, i) => (
          <Tab
            key={i}
            disableRipple
            icon={
              <Typography variant="caption">
                {getTimeZoneDate({ date: schedule.start }).tz('Europe/Lisbon').format('dddd')}
              </Typography>
            }
            label={
              <Typography variant="h6" gutterBottom>
                {getTimeZoneDate({ date: schedule.start }).tz('Europe/Lisbon').format('DD, MMM')}
              </Typography>
            }
            value={schedule.start}
          />
        ))}
      </Tabs>
    </Box>
  );
}
